// src/redux/features/currencyApi.ts

import { api } from '../services/api';
import { currencyURL } from '../../components/Data/baseURL';

export interface Currency {
  id?: number | string;
  uf?: string;

  currencycode: string;
  currencyname?: string;
  symbol?: string;

  label?: string;
  value?: string;

  [key: string]: unknown;
}

interface PaginatedCurrenciesResponse {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results: Currency[];
}

const isCurrencyArray = (response: unknown): response is Currency[] => {
  return Array.isArray(response);
};

const isPaginatedCurrenciesResponse = (response: unknown): response is PaginatedCurrenciesResponse => {
  return (
    typeof response === 'object' &&
    response !== null &&
    'results' in response &&
    Array.isArray((response as PaginatedCurrenciesResponse).results)
  );
};

export const currencyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrencies: builder.query<Currency[], void>({
      query: () => {
        console.log('GET CURRENCIES QUERY EXECUTED', currencyURL);

        return {
          url: currencyURL,
          method: 'GET',
        };
      },

      transformResponse: (response: unknown): Currency[] => {
        // console.log('RAW CURRENCIES RESPONSE:', response);

        console.log('RAW CURRENCIES RESPONSE:', response);

        if (isCurrencyArray(response)) {
          return response;
        }

        if (isPaginatedCurrenciesResponse(response)) {
          return response.results;
        }

        console.warn('Unexpected currencies response:', response);

        return [];
      },

      providesTags: ['Currencies'],
    }),
  }),

  overrideExisting: false,
});

export const { useGetCurrenciesQuery } = currencyApi;
